<p-panel header="Scegli il tema">
  <div class="grid">
    @for (theme of themes; track theme) {
      <div class="col-3">
        <button pButton (click)="changeTheme(theme)"
                [style.background]="theme.representativeColor"
                [style.border]="theme.representativeColor"
                pTooltip="{{getTooltip(theme)}}"
          tooltipPosition="left" [appendTo]="container">
          @if (theme.darkTheme) {
            <i class="pi pi-moon"></i>
          }
          @if (!theme.darkTheme) {
            <i class="pi pi-sun"></i>
          }
        </button>
      </div>
    }
  </div>
  <div #container style="display:inline-block; position: absolute"></div>
</p-panel>
